import React, {useState, useEffect} from 'react';
import * as S from './PartnerVideo.styles';

import {sendEvarData} from '@ibibo/analytics';

const PartnerVideo = ({timeZone}) => {
  const [langSelected, setLangSelect] = useState(false);
  const [videoLink, setVideoLink] = useState('');
  const [overlayView, setOverlayView] = useState(true);

  useEffect(() => {
    let isMount = true;
    const timer = setTimeout(() => {
      if(isMount){

      
      setOverlayView(false);
      }
    }, 10000);
    return ()=>{
      isMount= false;
      clearTimeout(timer);

    }
  }, []);

  const hoverHandle = () => {
    if (!langSelected && !overlayView) {
      setOverlayView(true);
    }
  };

  const videoLangSelect = lang => {
    sendEvarData(
      {
        prop54: `myPartner|signup|personalDetails|videoLanguage|${lang}`,
      },
      true,
    );

    setLangSelect(true);
    switch (lang) {
      case 'hindi':
        setVideoLink('https://mypartnerimgak.mmtcdn.com/media/promo-hi.mp4');
        setOverlayView(false);
        // setCookie('hindi');
        break;

      case 'kannada':
        setVideoLink('https://mypartnerimgak.mmtcdn.com/media/promo-ka.mp4');
        setOverlayView(false);
        // setCookie('gujurati');
        break;

      case 'telugu':
        setVideoLink('https://mypartnerimgak.mmtcdn.com/media/promo-te.mp4');
        setOverlayView(false);
        // setCookie('marathi');
        break;

      case 'tamil':
        setVideoLink('https://mypartnerimgak.mmtcdn.com/media/promo-ta.mp4');
        setOverlayView(false);
        break;

      case 'malayalam':
        setVideoLink('https://mypartnerimgak.mmtcdn.com/media/promo-ma.mp4');
        setOverlayView(false);
        break;

      case 'gujarati':
        setVideoLink('https://mypartnerimgak.mmtcdn.com/media/promo-gu.mp4');
        setOverlayView(false);
        break;

      case 'arabic':
        setVideoLink('https://mypartnerimgak.mmtcdn.com/LTDYTX2ZE3-60QW3580.mp4');
        setOverlayView(false);
        break;

      case 'englishGcc':
        setVideoLink('https://mypartnerimgak.mmtcdn.com/8UK7FN3OQD-EJH06X3B.mp4');
        setOverlayView(false);
        break;

      default:
        setVideoLink('https://mypartnerimgak.mmtcdn.com/media/promotion-with-flight.mp4');
        setOverlayView(false);
        break;
    }
  };
  return (
    <S.WhyPartnerVideoBlock>
      <S.VideoWrapper>
        <S.VideoInnerWrap id="videoBlock" onMouseOver={hoverHandle}>
          {(overlayView && (
            <S.VideoSelectWrap>
              <S.SelectHeadText>Choose audio language:</S.SelectHeadText>
              {timeZone ? (
                <>
                  <S.SelectOptionList>
                    <li onClick={() => videoLangSelect('englishGcc')}>English</li>
                    <li onClick={() => videoLangSelect('arabic')}>Arabic</li>
                  </S.SelectOptionList>
                </>
              ) : (
                <S.SelectOptionList>
                  <li onClick={() => videoLangSelect('english')}>English</li>
                  <li onClick={() => videoLangSelect('hindi')}>हिंदी</li>
                  <li onClick={() => videoLangSelect('kannada')}>ಕನ್ನಡ</li>
                  <li onClick={() => videoLangSelect('telugu')}>తెలుగు</li>
                  <li onClick={() => videoLangSelect('tamil')}>தமிழ்</li>
                  <li onClick={() => videoLangSelect('malayalam')}>മലയാളം</li>
                  <li onClick={() => videoLangSelect('gujarati')}>ગુજરાતી</li>
                </S.SelectOptionList>
              )}
            </S.VideoSelectWrap>
          )) ||
            null}
          {(!langSelected && (
            <video
              width="100%"
              height="100%"
              controls={true}
              autoPlay={false}
              muted
              playsInline
              style={{maxHeight: '320px', outline: 'none', borderRadius: '16px'}}
            >
              <source
                src={
                  timeZone
                    ? 'https://mypartnerimgak.mmtcdn.com/8UK7FN3OQD-EJH06X3B.mp4'
                    : 'https://mypartnerimgak.mmtcdn.com/media/promotion-with-flight.mp4'
                }
                type="video/mp4"
              />
            </video>
          )) || (
            <video
              width="100%"
              height="100%"
              controls={true}
              autoPlay={true}
              playsInline
              style={{maxHeight: '320px', outline: 'none', borderRadius: '16px'}}
              src={videoLink}
            >
              {/* <source src={videoBlock} type="video/mp4"/> */}
            </video>
          )}
        </S.VideoInnerWrap>
      </S.VideoWrapper>
    </S.WhyPartnerVideoBlock>
  );
};

export default PartnerVideo;
